import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { RxCross1 } from "react-icons/rx";
import { FiMapPin, FiUsers } from "react-icons/fi";
import { TbBed } from "react-icons/tb";
import { HiOutlineSpeakerphone } from "react-icons/hi";
import { RiHotelLine } from "react-icons/ri";
import SelectAndSearchHero from "./shared/SelectAndSearchHero";

const eventTypes = [
  {
    label: "Company Retreats",
    value: "Company Retreats",
  },
  {
    label: "Corporate Off-sites",
    value: "Corporate Off-sites",
  },
  {
    label: "Executive Meetings",
    value: "Executive Meetings",
  },
  {
    label: "Family Reunions",
    value: "Family Reunions",
  },
  {
    label: "Destination Weddings",
    value: "Destination Weddings",
  },
  {
    label: "Group Gateways",
    value: "Group Gateways",
  },
  {
    label: "Wellness Retreats",
    value: "Wellness Retreats",
  },
  {
    label: "Educational Camps or Workshops",
    value: "Educational Camps",
  },
  {
    label: "Special Events or Celebrations",
    value: "Special Events",
  },
  {
    label: "Training Programs",
    value: "Training Programs",
  },
];

const hotelTypes = [
  { label: "Airport Hotel", value: "Airport Hotel" },
  { label: "All-Inclusive Resort", value: "All-Inclusive Resort" },
  { label: "Beach Hotel", value: "Beach Hotel" },
  { label: "Boutique Hotel", value: "Boutique Hotel" },
  { label: "Budget Hotel", value: "Budget Hotel" },
  { label: "Business Hotel", value: "Business Hotel" },
  { label: "Casino Hotel", value: "Casino Hotel" },
  { label: "City Hotel", value: "City Hotel" },
  { label: "Desert Hotel", value: "Desert Hotel" },
  { label: "Eco-friendly Hotel", value: "Eco-friendly Hotel" },
  { label: "Floating Hotel", value: "Floating Hotel" },
  { label: "Glamping Hotel", value: "Glamping Hotel" },
  { label: "Golf Resorts", value: "Golf Resorts" },
  { label: "Heritage Hotel", value: "Heritage Hotel" },
  { label: "Historic Hotel", value: "Historic Hotel" },
  { label: "Island Hotel", value: "Island Hotel" },
  { label: "Luxury Hotel", value: "Luxury Hotel" },
  { label: "Resort Hotel", value: "Resort Hotel" },
  { label: "Safari Hotel", value: "Safari Hotel" },
  { label: "Wellness Hotel", value: "Wellness Hotel" },
];

const HotelVenuModal = ({
  cities,
  setFilters,
  showHotelVenue,
  setShowHotelVenue,
}) => {
  const [numberOfGuests, setNumberOfGuests] = useState("");
  const [numberOfRooms, setNumberOfRooms] = useState("");
  const [selectedEvent, setSelectedEvent] = useState({});
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedHotel, setSelectedHotel] = useState("");
  useEffect(() => {
    console.log(
      selectedCity,
      selectedEvent,
      selectedHotel,
      numberOfGuests,
      numberOfRooms
    );
    setFilters({
      city: selectedCity || "",
      eventType: selectedEvent || "",
      hotelType: selectedHotel || "",
      standingGuests: numberOfGuests,
      numberOfRooms: numberOfRooms,
    });
  }, [
    selectedCity,
    selectedEvent,
    selectedHotel,
    numberOfGuests,
    numberOfRooms,
  ]);
  if (!showHotelVenue) return null;
  return (
    <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center z-[9999]">
      <div
        className="fixed top-0 left-0 w-full h-full bg-black/70"
        onClick={() => setShowHotelVenue(false)}
        style={{ WebkitBackdropFilter: "blur(5px)" }}
      />

      <div className="relative flex flex-col bg-white rounded-lg shadow-lg w-[90%] md:w-[70vw] max-h-[90vh] overflow-visible">
        {/* Close button */}
        <button
          className="absolute top-2 right-2 sm:top-4 sm:right-4 p-2 z-[100]"
          onClick={() => setShowHotelVenue(false)}
        >
          <RxCross1 className="w-5 h-5" />
        </button>

        {/* Header */}
        <div className="px-6 pt-8 w-[75%]">
          <h1 className="text-lg sm:text-xl lg:text-2xl font-semibold text-start">
            Are you looking for venue + hotel accommodation?
          </h1>
        </div>

        {/* Form Grid */}
        <div className="p-4 sm:p-6 md:p-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
            {/* Number of Guests */}
            <div className="flex flex-col w-full">
              <div className="relative flex items-center w-full border border-gray-300 rounded-lg px-4 shadow-sm h-[40px] bg-white">
                <input
                  type="number"
                  min={0}
                  className="w-full pl-8 border-gray-300 rounded-md outline-none text-base placeholder-[#B0B0B0]"
                  placeholder="Guests"
                  value={numberOfGuests}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "" || (!isNaN(value) && Number(value) >= 0)) {
                      setNumberOfGuests(value);
                    }
                  }}
                  style={{
                    WebkitAppearance: "none",
                    MozAppearance: "textfield",
                  }}
                />
                <FiUsers className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-lg" />
              </div>
            </div>

            {/* Number of Rooms */}
            <div className="flex flex-col w-full">
              <div className="relative flex items-center w-full border border-gray-300 rounded-lg px-4 shadow-sm h-[40px] bg-white">
                <TbBed className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-lg" />
                <input
                  type="number"
                  min={0}
                  className="w-full pl-8 border-gray-300 rounded-md outline-none text-base placeholder-[#B0B0B0]"
                  placeholder="Rooms"
                  value={numberOfRooms}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "" || (!isNaN(value) && Number(value) >= 0)) {
                      setNumberOfRooms(value);
                    }
                  }}
                  style={{
                    WebkitAppearance: "none",
                    MozAppearance: "textfield",
                  }}
                />
              </div>
            </div>

            {/* City Select */}
            <div className="flex flex-col w-full">
              <div className="relative flex items-center w-full border border-gray-300 rounded-lg px-4 shadow-sm h-[40px]">
                <FiMapPin className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-lg" />
                <SelectAndSearchHero
                  options={cities}
                  selectedOption={selectedCity}
                  onSelect={(value) =>
                    setSelectedCity(value ? value.label : "")
                  }
                  placeholder={"Location"}
                  className="w-full h-[40px] pl-3 flex items-center justify-center placeholder-[#B0B0B0] text-[16px] font-[400] bg-transparent outline-none mb-1"
                  containerClassName="relative z-[101]"
                />
              </div>
            </div>

            {/* Event Type */}
            <div className="flex flex-col w-full">
              <div className="relative flex items-center w-full border border-gray-300 rounded-lg px-4 shadow-sm h-[40px]">
                <HiOutlineSpeakerphone className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-lg" />
                <SelectAndSearchHero
                  options={eventTypes}
                  selectedOption={selectedEvent.label}
                  onSelect={(value) =>
                    setSelectedEvent(value ? value.label : "")
                  }
                  placeholder={"Event Type"}
                  className="w-full h-[40px] pl-3 flex items-center justify-center placeholder-[#B0B0B0] text-[16px] font-[400] bg-transparent outline-none mb-1"
                  containerClassName="relative z-[101]"
                />
              </div>
            </div>
            {/* Hotel Type */}
            <div className="relative">
              <div className="relative flex items-center w-full border border-gray-300 rounded-lg px-4 shadow-sm h-[40px]">
                <RiHotelLine className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-lg" />
                <SelectAndSearchHero
                  options={hotelTypes}
                  selectedOption={selectedHotel.label}
                  onSelect={(value) =>
                    setSelectedHotel(value ? value.label : "")
                  }
                  placeholder={"Hotel Type"}
                  className="w-full h-[40px] pl-3 flex items-center justify-center placeholder-[#B0B0B0] text-[16px] font-[400] bg-transparent outline-none mb-1"
                  containerClassName="relative z-[101]"
                />
              </div>
            </div>

            {/* Search Button */}
            <div className="flex items-end">
              <Link to="/listing/2" className="w-full">
                <button className="w-full bg-[#FE4747] text-white py-2 px-4 rounded-lg text-base font-medium hover:bg-[#fe3333] transition-colors">
                  Search
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HotelVenuModal;
